import { faXmark, faCheck, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { Plan, FeatureItem } from '../../models/plan.model';

export class PlanVM implements Plan {
  constructor(
    public id: string,
    public titleKey: string,
    public subtitle: string,
    public features: FeatureItem[]
  ) {}
}

export class FeatureItemVM implements FeatureItem {
  name: string;
  isEnabled: boolean;

  constructor(name: string, isEnabled: boolean) {
    this.name = name;
    this.isEnabled = isEnabled;
  }

  getIcon(): IconDefinition {
    return this.isEnabled ? faCheck : faXmark;
  }
}
